import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    categoryData: [],
    headerNav:'index'
}

const actions = {
    
}

const mutations={
    setheadNav:function(nav)
    {
        state.headerNav=nav;
    }
}

export default{
    state,
    actions,
    mutations
}
